/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { AlertBar } from '@blend/enterprise-components';

export namespace Error {
  export interface Props {
    message?: string;
  }
}

const styles = StyleSheet.create({
  errorWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    top: '5%',
    width: '100%',
  },
});

export const Error: React.FC<Error.Props> = ({ message = 'Please try again later' }) => {
  return (
    <div className={css(styles.errorWrapper)} data-it="Pipeline-Error">
      <AlertBar data-dd-privacy="allow" icon="error" message={message} theme="error" />
    </div>
  );
};
